import type { ReactNode } from "react";

interface EmptyStateProps {
  icon?: string;
  title: string;
  description: string;
  children?: ReactNode;
}

export default function EmptyState({ icon = "ri-search-eye-line", title, description, children }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-16 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-secondary-50 text-secondary-600">
        <i className={`${icon} text-2xl`} />
      </span>
      <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">{title}</h3>
      <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-500">{description}</p>
      {children && <div className="mt-6 flex flex-wrap items-center justify-center gap-3">{children}</div>}
    </div>
  );
}